import React, {Component} from 'react'
import PropTypes from 'prop-types'

class BaskTotalItem extends Component {
    render() {
        return (
            <td className='BaskTotalItem'>
                {this.props.totalItems}
            </td>
        )
    }
}

BaskTotalItem.propTypes = {
    totalItems: PropTypes.number.isRequired,
}

export default BaskTotalItem
